import { AbstractControl, ValidatorFn } from '@angular/forms'

export class CareFinityValidators {
  /**
   * Match two controls if they are the same
   * @param firstControlName
   * @param secondControlName
   * @returns {(AC: AbstractControl) => any}
   * @constructor
   */
  static Match(firstControlName, secondControlName) {
    return (AC: AbstractControl) => {
      let firstControlValue = AC.get(firstControlName).value // to get value in input tag
      let secondControlValue = AC.get(secondControlName).value // to get value in input tag
      if (firstControlValue != secondControlValue) {
        AC.get(secondControlName).setErrors({ MatchFields: true })
      } else {
        return null
      }
    }
  }
}

export function fileExtensionValidator(allowedExtensions: string[]): ValidatorFn {
    return (control: AbstractControl) => {
        if (!control.value) {
            return null; // If no value, validation passes (you can change this if required)
        }

        const fileName = control.value.toLowerCase();
        const isValid = allowedExtensions.some(ext => fileName.endsWith(ext));

        return isValid ? null : { invalidFileExtension: true };
    };
}
